import { render } from "./DraftCard.vue?vue&type=template&id=253c2960&scoped=true"
import script from "./DraftCard.vue?vue&type=script&lang=js"
export * from "./DraftCard.vue?vue&type=script&lang=js"

import "./DraftCard.vue?vue&type=style&index=0&id=253c2960&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253c2960"]])

export default __exports__